/*
 * File: cell.service.ts                                                       *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 17th February 2022 11:48:25                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:25:31                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { Injectable } from '@angular/core';
import { ApiService } from '../../api/services/api.service';

import { Subject } from 'rxjs';
import { ProductExtra, Cell } from '@nousmedis/cc-types';
import { CcCellItemExtraFieldsFormComponent } from '../components/cell/cc-cell-item-extra-fields-form/cc-cell-item-extra-fields-form.component';

import { environment } from 'environment';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Product } from '@nousmedis/cc-types';
import { ProductDetailsComponent } from '../components/product/product-details/product-details.component';
import { Page } from '@nousmedis/cc-types';
import { ProductDetailsModalComponent } from '../components/product/product-details-modal/product-details-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CellService {
  protected get urlBase(): string { return this.api.getBaseUrl(); }

  get endpoint(): string {
    return this.urlBase + '/api/v1/catalog/idCatalog/fascicle/idFascicle/page/idPage/cells';
  }

  cleanCell: Subject<string> = new Subject<string>();
  moveCell: Subject<string> = new Subject<string>();

  constructor(private api: ApiService, private dialog: DialogService) { }

  private getBaseEndPoint(
    idCatalog: string,
    idFascicle: string,
    idPage: string
  ): string {
    const mapObj = {
      idCatalog: idCatalog,
      idFascicle: idFascicle,
      idPage: idPage,
    };
    let str = this.endpoint;
    str = str.replace(
      /\b(?:idCatalog|idFascicle|idPage)\b/gi,
      (matched: any) => mapObj[matched as keyof typeof mapObj]
    );
    return str;
  }

  moveProduct(
    idCatalog: string,
    idFascicle: string,
    fromIdPage: string,
    fromCell: string,
    toIdPage: string,
    toCell: string
  ) {
    const url =
      this.getBaseEndPoint(idCatalog, idFascicle, fromIdPage) + '/' + fromCell;
    return this.api.post(url, { toIdPage: toIdPage, toCell: toCell });
  }

  update(
    idCatalog: string,
    idFascicle: string,
    idPage: string,
    idCell: string,
    cell: Cell
  ) {
    const url =
      this.getBaseEndPoint(idCatalog, idFascicle, idPage) + '/' + idCell;

    return this.api.put(url, cell);
  }

  openProductDetails(product: Product) {
    return this.dialog.open(ProductDetailsModalComponent, {
      data: {
        product: product,
      },
    });
  }

  openExtraFieldsForm(
    fields: ProductExtra[],
    idCatalog: string,
    idFascicle: string,
    idPage: string,
    idCell: string,
    cell: Cell
  ): DynamicDialogRef {


    return this.dialog.open(CcCellItemExtraFieldsFormComponent, {
      width: '40vw',
      height: 'auto',
      header: 'Editar campos extra',
      modal: true,
      data: {
        title: 'Editar campos extra',
        entity: fields,
        idCatalog: idCatalog,
        idFascicle: idFascicle,
        idPage: idPage,
        idCell: idCell,
        cell: cell,
      },
    });
  }
}
